import { Component, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CurrentUserService } from '@services/current-user.service';
import { ConfirmationService } from 'primeng/api';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { BasePersistentNotification } from '../base-persistent-notification';

@Component({
  selector: 'vnm-impersonation-notification',
  styleUrls: ['./impersonation-notification.component.scss'],
  templateUrl: './impersonation-notification.component.html'
})
export class ImpersonationNotificationComponent extends BasePersistentNotification {
  userFullName$: Observable<String> = this.userService.user$.pipe(map((user) => user.fullName));

  constructor(
    private confirmationService: ConfirmationService,
    private translateService: TranslateService,
    private userService: CurrentUserService,
    el: ElementRef
  ) {
    super(el);
  }

  presentClearImpersonation() {
    this.userFullName$.pipe(take(1)).subscribe((name) => {
      this.confirmationService.confirm({
        message: this.translateService.instant('clear-impersonation.dialog-message', {
          userFullName: name
        }),
        accept: () => this.clearImpersonation()
      });
    });
  }

  private clearImpersonation() {
    this.userService
      .clearImpersonation()
      .pipe(take(1))
      .subscribe((url) => (window.location.href = url.toString()));
    this.onDismiss(new Event(null));
  }
}
